import { render, staticRenderFns } from "./ConnectLinesAnswer.vue?vue&type=template&id=13212394&scoped=true&"
import script from "./ConnectLinesAnswer.vue?vue&type=script&lang=ts&"
export * from "./ConnectLinesAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectLinesAnswer.vue?vue&type=style&index=0&id=13212394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13212394",
  null
  
)

export default component.exports